import React, { useState } from "react";
import { FaPlus, FaFileAlt, FaEdit, FaTrash, FaChevronDown, FaChevronUp, FaSearch } from "react-icons/fa";
import { toast } from "react-toastify";




const getColorByStato = (stato) => {
  switch (stato) {
    case "Da fare": return "red";
    case "In corso": return "orange";
    case "Completato": return "green";
    default: return "gray";
  }
};

const TabellaPreventivi = ({ preventivi, onAddPreventivo, onEditPreventivo, onDeletePreventivo, onDownloadPDF }) => {
  const [materialiOpzionali, setMaterialiOpzionali] = useState([]);
  const [isDirty, setIsDirty] = useState(false);
  const [expandedFields, setExpandedFields] = useState({});
  const [searchQuery, setSearchQuery] = useState("");

  const toggleExpand = (preventivoId, field) => {
    setExpandedFields((prev) => ({
      ...prev,
      [`${preventivoId}-${field}`]: !prev[`${preventivoId}-${field}`],
    }));
  };

  const safeToLowerCase = (value) => (typeof value === "string" ? value.toLowerCase() : "");

  const normalizeText = (text) => {
  if (text === null || text === undefined) return "";

  return String(text)
    .normalize("NFC")
    .replace(/\u00A0/g, " ")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .replace(/[\u0000-\u0008\u000B-\u000C\u000E-\u001F\u007F]/g, "")
    .replace(/[“”«»]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/[‐-‒–—]/g, "-")
    .replace(/\t/g, "    ")
    .trim();
};

  const filteredPreventivi = preventivi.filter((preventivo) => {
    const query = searchQuery.toLowerCase();
    return (
      safeToLowerCase(preventivo.cliente).includes(query) ||
      safeToLowerCase(preventivo.indirizzo).includes(query) ||
      safeToLowerCase(preventivo.email).includes(query) ||
      safeToLowerCase(preventivo.oggetto).includes(query) || // Aggiunto oggetto
      safeToLowerCase(preventivo.descrizione).includes(query) ||
      safeToLowerCase(preventivo.note).includes(query)
    );
  });

  const preventiviPerData = filteredPreventivi.reduce((acc, preventivo) => {
    const data = preventivo.dataEmissione
      ? new Date(preventivo.dataEmissione).toLocaleDateString("it-IT")
      : "Data non disponibile";
    if (!acc[data]) acc[data] = [];
    acc[data].push(preventivo);
    return acc;
  }, {});

  const dateOrdinate = Object.keys(preventiviPerData).sort((a, b) => {
    const dataA = preventiviPerData[a][0].dataEmissione
      ? new Date(preventiviPerData[a][0].dataEmissione)
      : new Date(0);
    const dataB = preventiviPerData[b][0].dataEmissione
      ? new Date(preventiviPerData[b][0].dataEmissione)
      : new Date(0);
    return dataB - dataA;
  });

  return (
    <div className="tabella-interventi-container" style={{ padding: "30px" }}>
      <h3 className="interventi-title">Gestione Preventivi</h3>

      <div className="search-container">
        <div className="search-input-wrapper">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Cerca preventivi (cliente, indirizzo, email, oggetto, descrizione, note...)"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>
      </div>

      <button className="add-intervento-button" onClick={onAddPreventivo}>
        <FaPlus /> Aggiungi Preventivo
      </button>

      {filteredPreventivi.length === 0 ? (
        <p className="text-gray-500 italic">Nessun preventivo disponibile</p>
      ) : (
        <div className="schede-interventi-wrapper">
          {dateOrdinate.map((data) => (
            <div key={data} className="gruppo-data">
              <h4 className="date-header">{data}</h4>
              {preventiviPerData[data].map((preventivo) => {
                const oggetto = typeof preventivo.oggetto === "string" ? preventivo.oggetto : "";
                const descrizione = typeof preventivo.descrizione === "string" ? preventivo.descrizione : "";
                const note = typeof preventivo.note === "string" ? preventivo.note : "";
                const indirizzo = typeof preventivo.indirizzo === "string" ? preventivo.indirizzo : "";
                const materiali = Array.isArray(preventivo.materiali) ? preventivo.materiali : [];

                const isOggettoLong = oggetto.length > 50;
                const isDescrizioneLong = descrizione.length > 50;
                const isNoteLong = note.length > 100;
                const isIndirizzoLong = indirizzo.length > 50;

                return (
                  <div key={preventivo.id} className="intervento-card">
                    <div
                      style={{
                        fontSize: "22px",
                        fontWeight: "bold",
                        color: "var(--verde-scuro)",
                      }}
                    >
                      {preventivo.cliente ?? "Senza cliente"}
                    </div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                        gap: "14px",
                      }}
                    >
                      <div className="campo">
                        <strong>ID:</strong> {preventivo.id ?? "-"}
                      </div>
                      <div className="campo">
                        <strong>Data Emissione:</strong>{" "}
                        {preventivo.dataEmissione
                          ? new Date(preventivo.dataEmissione).toLocaleDateString("it-IT")
                          : "-"}
                      </div>
                      <div className="campo campo-expandable">
                        <strong>Indirizzo:</strong>{" "}
                        {expandedFields[`${preventivo.id}-indirizzo`] || !isIndirizzoLong ? (
                          indirizzo || "-"
                        ) : (
                          <>
                            {indirizzo.slice(0, 50)}...
                            <button
                              className="expand-btn"
                              onClick={() => toggleExpand(preventivo.id, "indirizzo")}
                            >
                              {expandedFields[`${preventivo.id}-indirizzo`] ? (
                                <FaChevronUp />
                              ) : (
                                <FaChevronDown />
                              )}
                            </button>
                          </>
                        )}
                      </div>
                      <div className="campo">
                        <strong>Email:</strong> {preventivo.email ?? "-"}
                      </div>
                      <div className="campo">
                        <strong>Telefono:</strong> {preventivo.telefono ?? "-"}
                      </div>
                      <div className="campo">
                        <strong>Codice Fiscale:</strong> {preventivo.codiceFiscale ?? "-"}
                      </div>
                      <div className="campo">
                        <strong>Partita IVA:</strong> {preventivo.partitaIva ?? "-"}
                      </div>
                      <div className="campo">
                        <strong>Validità:</strong> {preventivo.validita ?? "30"} giorni
                      </div>
                      <div className="campo">
                        <strong>Costo Totale (incl. IVA):</strong>{" "}
                        {parseFloat(preventivo.costoTotaleConIva ?? 0).toFixed(2)} €
                      </div>
                      <div className="campo">
                        <strong>Escludi IVA:</strong> {preventivo.escludiIva ? "Sì" : "No"}
                      </div>
                      <div className="campo status" data-stato={preventivo.stato}>
                        <strong>Stato:</strong>
                        <span
                          className="status-indicator"
                          style={{
                            backgroundColor: getColorByStato(preventivo.stato),
                          }}
                        ></span>
                        {preventivo.stato ?? "Da fare"}
                      </div>
                    </div>
                    <div className="campo lavori-eseguiti campo-expandable">
                      <strong>Oggetto:</strong>{" "}
                      {expandedFields[`${preventivo.id}-oggetto`] || !isOggettoLong ? (
                        oggetto || "-"
                      ) : (
                        <>
                          {oggetto.slice(0, 50)}...
                          <button
                            className="expand-btn"
                            onClick={() => toggleExpand(preventivo.id, "oggetto")}
                          >
                            {expandedFields[`${preventivo.id}-oggetto`] ? (
                              <FaChevronUp />
                            ) : (
                              <FaChevronDown />
                            )}
                          </button>
                        </>
                      )}
                    </div>
                    <div className="campo lavori-eseguiti campo-expandable">
                      <strong>Descrizione:</strong>{" "}
                      {expandedFields[`${preventivo.id}-descrizione`] || !isDescrizioneLong ? (
                        descrizione || "-"
                      ) : (
                        <>
                          {descrizione.slice(0, 50)}...
                          <button
                            className="expand-btn"
                            onClick={() => toggleExpand(preventivo.id, "descrizione")}
                          >
                            {expandedFields[`${preventivo.id}-descrizione`] ? (
                              <FaChevronUp />
                            ) : (
                              <FaChevronDown />
                            )}
                          </button>
                        </>
                      )}
                    </div>
                    <div className="campo lavori-eseguiti campo-expandable">
                      <strong>Note:</strong>{" "}
                      {expandedFields[`${preventivo.id}-note`] || !isNoteLong ? (
                        note || "-"
                      ) : (
                        <>
                          {note.slice(0, 100)}...
                          <button
                            className="expand-btn"
                            onClick={() => toggleExpand(preventivo.id, "note")}
                          >
                            {expandedFields[`${preventivo.id}-note`] ? (
                              <FaChevronUp />
                            ) : (
                              <FaChevronDown />
                            )}
                          </button>
                        </>
                      )}
                    </div>
                    <div className="campo materiali campo-expandable">
                      <strong>Materiali:</strong>{" "}
                      <button
                        className="expand-btn"
                        onClick={() => toggleExpand(preventivo.id, "materiali")}
                      >
                        {expandedFields[`${preventivo.id}-materiali`] ? (
                          <FaChevronUp />
                        ) : (
                          <FaChevronDown />
                        )}
                      </button>
                      {expandedFields[`${preventivo.id}-materiali`] && (
                        <div className="materiali-table-container" style={{ marginTop: "10px" }}>
                          {materiali.length > 0 ? (
                            <table className="interventi-table">
                              <thead>
                                <tr>
                                  <th>Miniatura</th>
                                  <th>Codice</th>
                                  <th>Descrizione</th>
                                  <th>Quantità</th>
                                  <th>Costo Unitario (€)</th>
                                  <th>Costo Totale (€)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {materiali.map((materiale, index) => {
                                  const costoUnitario = parseFloat(materiale.costoUnitario) || 0;
                                  const quantita = parseInt(materiale.quantita, 10) || 0;
                                  const costoTotale = quantita * costoUnitario;
                                  return (
                                    <tr key={index}>
                                      <td>
                                        {materiale.thumbnail ? (
                                          <img
                                            src={`https://interventi.synology.me:5050${materiale.thumbnail}`}
                                            alt={materiale.descrizioneMateriale}
                                            style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                            onError={() => console.warn(`Impossibile caricare la miniatura per ${materiale.codiceMateriale}`)}
                                          />
                                        ) : (
                                          "Nessuna miniatura"
                                        )}
                                      </td>
                                      <td>{materiale.codiceMateriale || "N/A"}</td>
                                      <td>{materiale.descrizioneMateriale || "N/A"}</td>
                                      <td>{quantita}</td>
                                      <td>{costoUnitario.toFixed(2)}</td>
                                      <td>{costoTotale.toFixed(2)}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          ) : (
                            <p>Nessun materiale associato</p>
                          )}
                        </div>
                        
                      )}

  <div className="modal-section">
    <h3>Materiali Opzionali (fuori preventivo)</h3>
    <textarea
     placeholder="Descrizione dei materiali opzionali o lista manuale"
      value={JSON.stringify(materialiOpzionali, null, 2)}
      onChange={(e) => {
        try {
         const parsed = JSON.parse(e.target.value);
         setMaterialiOpzionali(parsed);
         setIsDirty(true);
       } catch (err) {
          toast.error("Formato JSON non valido per materiali opzionali");
       }
      }}
    rows="6"
    style={{
      width: "100%",
      padding: "10px",
      fontFamily: "monospace",
      fontSize: "12px",
    }}
  />
</div>

                    </div>
                    <div className="azioni">
                      <button onClick={() => onDownloadPDF(preventivo.id)} className="view-btn">
                        <FaFileAlt style={{ marginRight: "6px" }} /> PDF
                      </button>
                      <button onClick={() => onEditPreventivo(preventivo)} className="edit-btn">
                        <FaEdit style={{ marginRight: "6px" }} /> Modifica
                      </button>
                      <button onClick={() => onDeletePreventivo(preventivo.id)} className="delete-btn">
                        <FaTrash style={{ marginRight: "6px" }} /> Cancella
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TabellaPreventivi;